import { queryClient } from "@/queryClient";
import { PERMISSIONS_QUERY_KEY } from "@/entities/session/model/keys";
import { PERMISSIONS } from "@/shared/config/permissions";

/**
 * The permissions the signed-in user holds, read straight from the query cache for code that runs
 * outside React (the response interceptor, error formatting). Anything that is not an array — an empty
 * cache, a stale persisted entry of another shape — reads as "holds nothing" rather than throwing, since
 * a throw here would replace the original request error for every caller.
 */
export function heldPermissions(): string[] {
    const cached: unknown = queryClient.getQueryData(PERMISSIONS_QUERY_KEY);
    return Array.isArray(cached) ? (cached as string[]) : [];
}

/** Whether the signed-in user may read the account's payment standing. */
export function canViewBilling(): boolean {
    return heldPermissions().includes(PERMISSIONS.BillingView);
}
